import React, { useState } from "react";
import "./Sidebar.css";

import logodark from "../images/urology-logo.png";
import logAdmin from "../images/sidenav/admin-updated-logo.svg";
import urology_icon from "../images/urology-icon.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModal } from "./SideBarSlice";

import dashboardActive from "../images/side-nav-icons/Dashboard-Active.svg";
import dashboardInactive from "../images/side-nav-icons/Dashboard.svg";

import patientsActive from "../images/side-nav-icons/Patients-Active.svg";
import patientsInactive from "../images/side-nav-icons/Patients.svg";

import analyticsActive from "../images/side-nav-icons/Analytics-Active.svg";
import analyticsInactive from "../images/side-nav-icons/Analytics.svg";

import forumActive from "../images/side-nav-icons/Forum-Active.svg";
import forumInactive from "../images/side-nav-icons/Forum.svg";

import settingsActive from "../images/side-nav-icons/Settings-Active.svg";
import settingsInactive from "../images/side-nav-icons/Settings.svg";

import helpActive from "../images/side-nav-icons/Help-Active.svg";
import helpInactive from "../images/side-nav-icons/Help.svg";

import contactActive from "../images/side-nav-icons/Contact Us-Active.svg";
import contactInactive from "../images/side-nav-icons/Contact Us.svg";

import AIActive from "../images/side-nav-icons/AI Assist-Active.svg";
import AIInactive from "../images/side-nav-icons/AI Assist.svg";

import signoutActive from "../images/side-nav-icons/Sign Out-Active.svg";
import policyActive from "../images/side-nav-icons/policy-white.png";
import policy from "../images/side-nav-icons/Policy.png";

import templateActive from "../images/side-nav-icons/Template-white.png";
import template from "../images/side-nav-icons/Template.png";

import surveyActive from "../images/side-nav-icons/survey-management-white-logo.svg";
import survey from "../images/side-nav-icons/survey-management-black-logo.svg";

import mediaManagementActive from "../images/side-nav-icons/education-management-white-icon.png";
import mediaManagement from "../images/side-nav-icons/education-management-bloack-icon.png";

import signoutInactive from "../images/side-nav-icons/Sign Out.svg";
import { userlogout } from "../public/Signin/loginSlice";

function SidebarComponent({ isOpen }) {
  const role = useSelector((state) => state.login.data.role);
  // const role = "ADMIN"; // static role for test purposes

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeItem, setActiveItem] = useState("Dashboard");

  const handleClick = (item) => {
    setActiveItem(item);
    if (item == "Sign Out") {
      handleLogout();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.clear();
    dispatch(userlogout());
    navigate("/signin");
  };

  const renderMenuItems = () => {
    // Define the menu based on the role
    const commonMenuItems = [];

    let roleBasedMenuItems = [];
    if (role === "ADMIN") {
      roleBasedMenuItems = [
        {
          label: "Dashboard",
          iconActive: dashboardActive,
          iconInactive: dashboardInactive,
          path: "/admin/dashboard",
        },
        {
          label: "Doctors",
          iconActive: patientsActive,
          iconInactive: patientsInactive,
          path: "/admin/provider/listing",
        },
        // {
        //   label: "Patients",
        //   iconActive: patientsActive,
        //   iconInactive: patientsInactive,
        //   path: "/admin/patient/list",
        // },
        {
          label: "Analytics",
          iconActive: analyticsActive,
          iconInactive: analyticsInactive,
          path: "/admin/analytics",
        },
        {
          label: "Forum",
          iconActive: forumActive,
          iconInactive: forumInactive,
          path: "/admin/forum",
        },
        // {
        //   label: "Media Management",
        //   iconActive: mediaManagementActive,
        //   iconInactive: mediaManagement,
        //   path: "/admin/media-management",
        // },
        {
          label: "Education Management",
          iconActive: mediaManagementActive,
          iconInactive: mediaManagement,
          path: "/admin/education-management",
        },
        {
          label: "Survey Management",
          iconActive: surveyActive,
          iconInactive: survey,
          path: "/admin/survey/survey-list",
        },
        {
          label: "Template Management",
          iconActive: templateActive,
          iconInactive: template,
          path: "/admin/template-manager",
        },
        {
          label: "Policies",
          iconActive: policyActive,
          iconInactive: policy,
          path: "/admin/policies",
        },
      ];
    } else if (role === "PROVIDER" || role === "DOCTOR") {
      roleBasedMenuItems = [
        {
          label: "Dashboard",
          iconActive: dashboardActive,
          iconInactive: dashboardInactive,
          path: "/doctor/dashboard",
        },

        {
          label: "Forum",
          iconActive: forumActive,
          iconInactive: forumInactive,
          path: "/doctor/forum",
        },
        {
          label: "Survey Management",
          iconActive: surveyActive,
          iconInactive: survey,
          path: "/doctor/survey/survey-list",
        },
        {
          label: "Feedback",
          iconActive: helpActive,
          iconInactive: helpInactive,
          path: "/doctor/feedback",
        },
      ];
    }

    return [...roleBasedMenuItems, ...commonMenuItems].map((item, index) => (
      <Link key={index} to={item.path}>
        <li
          onClick={() => handleClick(item.label)}
          className={`menu-item ${activeItem === item.label ? "active" : ""}`}
        >
          <img
            src={item.iconActive}
            alt={item.label}
            className="dashboard-icon-active"
          />
          <img
            src={item.iconInactive}
            alt="dashboard-img-inactive"
            className="dashboard-icon-inactive"
          />

          {isOpen && <span>{item.label}</span>}
        </li>
      </Link>
    ));
  };

  return (
    <div className={`sidebar ${isOpen ? "" : "sidebar-collapsed"}`}>
      <div className="sidebar-logo mb-2">
        {isOpen ? (
          role === "ADMIN" ? (
            <img src={logAdmin} alt="Logo" className="logo_main" />
          ) : (
            <img src={logodark} alt="Logo" className="logo_main" />
          )
        ) : (
          <img src={urology_icon} alt="Logo_icon" className="logo_icon" />
        )}
      </div>
      <ul className="sidebar-menu">{renderMenuItems()}</ul>
    </div>
  );
}

export default SidebarComponent;
